"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../../Context");
var _header = require("../../../constants/header");
var actions = _interopRequireWildcard(require("../../../actions"));
var _appconfig = require("../../../selectors/appconfig");
var _menu = require("../../../selectors/menu");
var _AuthStrategy = require("../../../services/AuthStrategy");
var _NavIcon = _interopRequireDefault(require("./NavIcon"));
var _Search = _interopRequireDefault(require("../Search"));
var _Notifications = _interopRequireDefault(require("./Notifications"));
var _User = _interopRequireDefault(require("./icons/User"));
var _Logout = _interopRequireDefault(require("./icons/Logout"));
var Styled = _interopRequireWildcard(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Nav = ({
  headerActions,
  searchValueHandler
}) => {
  var _config$auth;
  const config = (0, _react.useContext)(_Context.ConfigContext);
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const solutions = (0, _Context.useSelector)(_menu.getSolutions);
  const dispatch = (0, _Context.useDispatch)();
  const openProfile = () => {
    window.location = `${appconfig.accountPrefix === '/' ? '' : appconfig.accountPrefix}/edit`;
  };
  const logout = () => {
    _AuthStrategy.authStrategy.logout((endpointURL, method, options) => {
      dispatch(actions.logout(endpointURL, method, options));
    });
  };
  const withSearch = (0, _react.useMemo)(() => {
    var _config$appFrame;
    return appconfig.search !== _header.HEADER_BUTTON_STATES.off && (config === null || config === void 0 ? void 0 : (_config$appFrame = config.appFrame) === null || _config$appFrame === void 0 ? void 0 : _config$appFrame.search) !== _header.HEADER_BUTTON_STATES.off && (searchValueHandler || solutions.length > 0);
  }, [appconfig.search, config.appFrame.search, searchValueHandler, solutions.length]);
  return _react.default.createElement(Styled.Nav, null, withSearch && _react.default.createElement(_Search.default, {
    solutions: solutions,
    searchValueHandler: searchValueHandler,
    disabled: appconfig.search === _header.HEADER_BUTTON_STATES.disabled
  }), _react.default.Children.toArray(headerActions), appconfig.notifications !== _header.HEADER_BUTTON_STATES.off && appconfig.accountPrefix && _react.default.createElement(_Notifications.default, {
    title: locale.notifications,
    disabled: appconfig.notifications === _header.HEADER_BUTTON_STATES.disabled
  }), appconfig.profile !== _header.HEADER_BUTTON_STATES.off && appconfig.accountPrefix && _react.default.createElement(_NavIcon.default, {
    title: locale.myProfile,
    action: openProfile,
    disabled: !appconfig.accountPrefix || appconfig.profile === _header.HEADER_BUTTON_STATES.disabled
  }, _react.default.createElement(_User.default, null)), _react.default.createElement(_NavIcon.default, {
    title: locale.logout,
    action: logout,
    disabled: !((_config$auth = config.auth) !== null && _config$auth !== void 0 && _config$auth.connector)
  }, _react.default.createElement(_Logout.default, null)));
};
var _default = exports.default = Nav;